<template>
  <a-tabs @change="changeTabs" v-model:activeKey="activeKey">
    <a-tab-pane key="base" tab="基本信息">
      <a-form ref="formRef" name="base" :model="form">
        <dc-layout-card :span="6">
          <dc-form-item label="客户规模">
            <CosInput v-model:value="form.enterpriseScale" view />
          </dc-form-item>
          <dc-form-item label="年产值">
            <CosInput v-model:value="form.gdp" view />
          </dc-form-item>
          <dc-form-item label="平均BSR">
            <CosInput v-model:value="form.avgBsr" view />
          </dc-form-item>
          <dc-form-item label="配送方式">
            <CosInput v-model:value="form.delivery" view />
          </dc-form-item>
          <dc-form-item label="主营市场">
            <CosInput v-model:value="form.mainMarket" view />
          </dc-form-item>
          <dc-form-item label="销往地区">
            <CosInput v-model:value="form.sellsArea" view />
          </dc-form-item>
          <dc-form-item label="网店品牌">
            <CosInput v-model:value="form.brand" view />
          </dc-form-item>
          <dc-form-item label="网店平台">
            <CosInput v-model:value="form.platform" view />
          </dc-form-item>
          <dc-form-item label="开店站点" :span="24">
            <CosInput v-model:value="form.site" view />
          </dc-form-item>
          <dc-form-item label="主营产品" :span="24">
            <CosInput v-model:value="form.mainProducts" view />
          </dc-form-item>
        </dc-layout-card>
      </a-form>
    </a-tab-pane>

    <a-tab-pane key="contact" tab="联系人">
      <cos-table
        ref="contactTableRef"
        serial
        v-model:search="contactQueryForm"
        :columns="contactColumns"
        :tableId="tableIdByPath('contacts')"
        @fetch="getContactList"
      />
    </a-tab-pane>

    <a-tab-pane key="goodsCategories" tab="商品类目">
      <cos-table
        ref="goodsTableRef"
        serial
        v-model:search="goodsQueryForm"
        :columns="goodsColumns"
        :tableId="tableIdByPath('goodsCategories')"
        @fetch="getGoodsCategories"
      />
    </a-tab-pane>
  </a-tabs>
</template>

<script lang="ts" setup>
import { onMounted, ref, computed } from 'vue'
import { tableIdByPath } from '@/utils'
import CosInput from '@/components/Antd/CosInput/index.vue'
import request from '@/utils/request'
const contactTableRef = ref()
const goodsTableRef = ref()
const formRef = ref()
const loading = ref(false)
const form = ref<any>({ enterpriseScale: '' })
const activeKey = ref('base')

const props = defineProps({
  cosId: String,
  customerName: String
})

const contactQueryForm = ref({ cosId: props.cosId, customerName: props.customerName })
const goodsQueryForm = ref({ cosId: props.cosId, customerName: props.customerName })

const fetch = () => {
  changeTabs(activeKey.value)
}

const getInfo = () => {
  request
    .post('lbu/api/tungee/customer/detail', { cosId: props.cosId, customerName: props.customerName })
    .then((res) => {
      if (res.data) {
        form.value = res.data
      }
    })
}

const getContactList = (queryForm: object, callBack: (res: any) => void) => {
  request.post('lbu/api/tungee/contact/page', queryForm).then((res) => {
    callBack(res)
  })
}

const getGoodsCategories = (queryForm: object, callBack: (res: any) => void) => {
  request.post('lbu/api/tungee/goodsCategories/page', queryForm).then((res) => {
    callBack(res)
  })
}

const goodsColumns = computed(() => [
  { title: '名称', dataIndex: 'name', width: 150 },
  { title: '数量', dataIndex: 'quantity', width: 150 },
  { title: '占比', dataIndex: 'pct', width: 150 }
])

const contactColumns = computed(() => [
  { title: '联系方式', dataIndex: 'contactInformation', width: 150 },
  { title: '联系人', dataIndex: 'contacts', width: 150 },
  { title: '来源', dataIndex: 'source', width: 150 }
])

onMounted(() => {
  fetch()
})
// 标签页切换
const changeTabs = (tag: string) => {
  if (tag === 'base') {
    getInfo()
  } else if (tag === 'contact') {
    contactTableRef.value?.fetch()
  } else if (tag === 'goodsCategories') {
    goodsTableRef.value?.fetch()
  }
}

defineExpose({ fetch })

</script>

<script lang="ts">
export default { name: 'TabsTungee' }
</script>
